import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SubscriptionServiceService } from '../services/subscription-service.service';
import { Router } from '@angular/router';
import { ClientServiceService } from '../services/client-service.service';
import { formatDate } from '@angular/common';
import { LangService } from '../services/lang.service';

@Component({
  selector: 'app-subscriptions',
  templateUrl: './subscriptions.component.html',
  styleUrls: ['./subscriptions.component.css']
})
export class SubscriptionsComponent implements OnInit {

  auth_client_token: any = null;
  subscriptions: any = [];
  
  current_subscription_id: string = "";
  isModalOpen: boolean = false;

  constructor(
    private subscription_service: SubscriptionServiceService,
    private router: Router,
    private client_service: ClientServiceService,
    private langService: LangService
  ) {}

  getFormattedDate(date: string | Date | null): string {
    if (!date) return '-';
  
    const lang = this.langService.currentLang;

    const formatMap: Record<string, string> = {
      en: 'MMM d, yyyy',
      de: 'd. MMM yyyy',
      ja: 'yyyy年M月d日'
    };
  
    const format = formatMap[lang] || formatMap['en'];
  
    return formatDate(date, format, 'en-US');
  }

  openModal(event: Event, orderId: string) {
    event.preventDefault();
    this.current_subscription_id = orderId;
    this.isModalOpen = true;
  }

  handleModalClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    const currentTarget = event.currentTarget as HTMLElement;

    if (target === currentTarget) {
      this.isModalOpen = false;
      return;
    }
    
    if(target.dataset["action"] === "confirm") {
      this.subscription_service.remove_subscription(this.auth_client_token, this.current_subscription_id).subscribe({
        next: (data) => {
          this.current_subscription_id = "";
          this.get_subscriptions();
        },
        error: (err) => {
          // console.log(err);
        }
      })
        
      this.isModalOpen = false;
      return;
    }

    if(target.dataset["action"] === "keep") {
      this.isModalOpen = false;
      return;
    }

  }

  ngOnInit(): void {
    this.auth_client_token = localStorage.getItem("auth_client_token");
    if(!this.auth_client_token) {
      this.router.navigate(["/login"]);
    };
    this.get_subscriptions();
    this.get_customer_detail();
  }

  get_subscriptions() {
    this.subscription_service.get_all_orders(this.auth_client_token).subscribe({
      next: (data) => {
        this.subscriptions = data;
      },
      error: (err) => {
        // console.log(err);
      }
    })
  }

  // get_active_subscriptions() {
  //   this.subscription_service.get_active_subscription(this.auth_client_token).subscribe({
  //     next: (data) => {
  //       this.active_subscription = data;
  //       this.can_cancel = data.store !== "stripe" && data.store !== "paypal"
  //     },
  //     error: (err) => {
  //       // console.log(err);
  //     }
  //   })
  // }

  get_customer_detail() {
    this.client_service.get_customer_info(this.auth_client_token).subscribe({
      next: (data) => {
        if (data.parent_id || data.status !== 'Active') {
          this.router.navigate(["/dashboard"]);
        }
      },
      error: (err) => {
        // console.log(err);
      }
    })
  }
}
